<section>
    <div class="notification-centre-toolbar mb-2">
        <h2>{{ title }}</h2>
        <div class="notification-centre-actions">
            <button mat-stroked-button class="action-secondary" *ngIf="!isDeleting && !isEditing"
                (click)="startEdit()">Edit...</button>
            <button mat-stroked-button class="action-danger" *ngIf="!isDeleting && !isEditing"
                [disabled]="watches.length === 0" (click)="startDelete()">Delete...</button>
            <button mat-raised-button class="action-danger-filled" *ngIf="isDeleting" [disabled]="!hasSelectedDeletes"
                (click)="deleteSelected()">Delete Selected</button>
            <button mat-raised-button color="primary" *ngIf="isEditing" (click)="saveChanges()">Save Changes</button>
            <button mat-stroked-button *ngIf="isDeleting || isEditing" (click)="cancelMode()">Cancel</button>
        </div>
    </div>

    <app-notification-watch-list [watches]="watches" [isEditing]="isEditing" [isDeleting]="isDeleting" [sort]="sort"
        (openWatch)="openWatch($event)" (toggleEnabled)="onToggleEnabled($event)"
        (watchChanged)="onWatchChanged($event)" (toggleDeleteSelection)="onToggleDeleteSelection($event)"
        (sortChanged)="onSortChanged($event)">
    </app-notification-watch-list>
</section>